import { getTrackingService } from './TrackingServiceInstance';
import { triggerDeferredConversion } from './v4.visitor-properties';

export { triggerDeferredConversion };

import type {
    TrackAnswerClickArgs,
    TrackFormSubmitArgs,
    TrackMultipleChoiceClickArgs,
} from '$lib/types/tracking';

export const trackButtonClick = (buttonComponentId: string, buttonContent: { clickId: string }) => {
    getTrackingService().getStrategy().trackButtonClick(buttonComponentId, buttonContent);
};

export const trackImageClick = (imageComponentId: string, clickId: string) => {
    getTrackingService().getStrategy().trackImageClick(imageComponentId, clickId);
};

export const trackFormSubmit = (args: TrackFormSubmitArgs) => {
    getTrackingService().getStrategy().trackFormSubmit(args);
};

export const trackMultipleChoiceClick = (args: TrackMultipleChoiceClickArgs) => {
    getTrackingService().getStrategy().trackMultipleChoiceClick(args);
};

export const trackAnswerClick = (args: TrackAnswerClickArgs) => {
    getTrackingService().getStrategy().trackAnswerClick(args);
};

export const trackCalendly = () => {
    getTrackingService().getStrategy().trackCalendly();
};

export const trackCal = () => {
    getTrackingService().getStrategy().trackCal();
};

export const trackGHL = () => {
    getTrackingService().getStrategy().trackGHL();
};

export const trackHubSpot = () => {
    getTrackingService().getStrategy().trackHubSpot();
};

export const trackIClosed = () => {
    getTrackingService().getStrategy().trackIClosed();
};

export const trackPage = (pageData: {
    pageName: string;
    tag: string;
    campaignId: string;
    pageSlug: string;
    isLastPage: boolean;
    pageId: string;
    fromPageId: string | null;
    fromPageName: string | null;
}) => {
    getTrackingService().getStrategy().trackPage(pageData);
};

export const trackVariant = (pageName: string) => {
    getTrackingService().getStrategy().trackVariant(pageName);
};

export const trackCookies = (integrations: string[]) => {
    getTrackingService().getStrategy().trackCookies(integrations);
};

export const trackBadgeImpression = (campaignId: string, companyId: string) => {
    getTrackingService().getStrategy().trackBadgeImpression(campaignId, companyId);
};

export const trackBadgeClick = (campaignId: string, companyId: string) => {
    getTrackingService().getStrategy().trackBadgeClick(campaignId, companyId);
};
